const obj = {
  /**交易数据 */
  orderTradeData:"system/statistics/orderTradeData",
  /**交易订单来源 */
  orderTradeSource:"system/statistics/orderTradeSource",
  /**订单交易分布 */
  orderTradeDistribute:"system/statistics/orderTradeDistribute",
  /**下单分析 */
  orderAnalyze:"/system/statistics/orderAnalyze",
  /**下单分析 -  导出 */
  orderAnalyzeExport:"/system/statistics/orderAnalyzeExport",
  /**注册用户 */
  registerMember:"/system/statistics/registerMember",
  /**商品类目销售分析 */
  categorySaleAnalyze:"system/statistics/categorySaleAnalyze",
  /**商品销售情况 */
  goodsSaleAnalyze:"/system/statistics/goodsSaleAnalyze",
  /**商品类目分析导出 */
  categorySaleAnalyzeExport:"system/statistics/categorySaleAnalyzeExport",
  /**商品销售情况导出 */
  goodsSaleAnalyzeExport:"/system/statistics/goodsSaleAnalyzeExport",
  /*商品交易额排行 */
  goodsTradeAmountRank:'/system/statistics/goodsTradeAmountRank',
  /*商品成交量排行 */
  goodsTradeVolumeRank:'system/statistics/goodsTradeVolumeRank',
  /*店铺交易排行 */
  storeTransactionRank:'system/statistics/storeTransactionRank',
  /* 搜索词排行*/
  searchTermsRank:'system/statistics/searchTermsRank',
  /* 用户交易排行*/
  memberTradeAmountRank:'system/statistics/memberTradeAmountRank',
  /* 类目排行*/
  categoryRank:'system/statistics/categoryRank',
  /**店铺分析 */
  storeAnalyze:"system/statistics/storeAnalyze",
  /**店铺分析导出 */
  storeAnalyzeExport:"system/statistics/storeAnalyzeExport",
  /**实时用户数据 */
  realUser:"/system/statistics/realUser",
  /**实时用户图标数据 */
  realUserGraph:"/system/statistics/realUserGraph",
  /**实时销售图标数据 */
  realSaleGraph:"system/statistics/realSaleGraph",
  /**实时销售数据 */
  realSale:"system/statistics/realSale",
  /**平台整体数据 */
  platform:"/system/statistics/platform",
  /**整体看板业绩销售指标 */
  allSale:"/system/statistics/allSale",
  /**整体看板  业绩销售指标图标 */
  allSaleGraph:"/system/statistics/allSaleGraph",
  /**整体看板  售后指标 */
  afterSale:"system/statistics/afterSale",
  /**整体看板售后指标图标 */
  afterSaleGraph:"system/statistics/afterSaleGraph",
  /**整体用户指标 */
  allUser:"system/statistics/allUser",
  /**整体看板 用户指标图标 */
  allUserGraph:"system/statistics/allUserGraph",
  /**类目排行导出 */
  categoryRankExport:"system/statistics/categoryRankExport",
  /**类目排行导出 */
  memberTradeAmountExport:"system/statistics/memberTradeAmountExport",
  /**类目排行导出 */
  searchTermsExport:"system/statistics/searchTermsExport",
  /**类目排行导出 */
  storeTransactionExport:"system/statistics/storeTransactionExport",
  /**类目排行导出 */
  goodsTradeVolumeExport:"system/statistics/goodsTradeVolumeExport",
  /**类目排行导出 */
  goodsTradeAmountExport:"system/statistics/goodsTradeAmountExport",
  aaa:"/system/statistics/tempExport"
}
export default obj;
  